import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { Card, CardContent, CardTitle /*, CardDescription */ } from '@worldcoo/ui/components/card';
import { Button } from '@worldcoo/ui/components/button';
import { DonatingIllustration } from '@worldcoo/ui/custom/donating-illustration';
import { motion } from 'motion/react';
import { useOnboardingFormStore } from '@/lib/onboarding-form-store';
// import { useMutation } from '@tanstack/react-query';
// import { createOnboardingContractOptions } from '@/lib/queries';
// import { useState } from 'react';
// import { downloadFile } from '@worldcoo/ui/components/form';
// import { generateCaptchaToken } from '@/lib/captcha';
// import { toast } from 'sonner';
// import { DownloadIcon } from 'lucide-react';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@worldcoo/ui/components/select';

export const Route = createFileRoute('/ngos/onboarding/success')({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useLingui();
	const navigate = useNavigate();
	const reset = useOnboardingFormStore((s) => s.reset);
	// const formData = useOnboardingFormStore((s) => s.formData);
	// const [contractLocale, setContractLocale] = useState<'en' | 'es' | 'ca' | 'it'>('es');
	// const { mutateAsync: createContract, isPending: isContractPending } = useMutation(createOnboardingContractOptions());

	const handleGoToProjects = (e: React.MouseEvent) => {
		e.preventDefault();
		reset();

		if (!document.startViewTransition) {
			navigate({ to: '/ngos/projects' });
			return;
		}

		const transition = document.startViewTransition(() => {
			navigate({ to: '/ngos/projects' });
			return new Promise<void>((resolve) => {
				const observer = new MutationObserver(() => {
					if (document.querySelector('[data-slot="sidebar"]')) {
						observer.disconnect();
						resolve();
					}
				});
				observer.observe(document.body, { childList: true, subtree: true });
				setTimeout(() => {
					observer.disconnect();
					resolve();
				}, 3000);
			});
		});
		// An aborted/superseded transition rejects `.ready` with InvalidStateError; expected, not actionable (TEC-3546).
		transition.ready.catch(() => {});
	};

	// const handleDownloadContract = async () => {
	// 	try {
	// 		const captchaToken = await generateCaptchaToken();
	// 		const base64 = await createContract({
	// 			data: {
	// 				legalId: formData.contactLegalId,
	// 				legalName: `${formData.contactLegalFirstname} ${formData.contactLegalLastname}`,
	// 				ngoName: formData.name,
	// 				legalEmail: formData.contact1Email,
	// 				urlProtection: formData.privacyUrl,
	// 				beneficiariName: formData.bankAccountName,
	// 				SWIFT: formData.bankInfo.bankSwiftCode ?? '',
	// 				IBAN: formData.bankInfo.bankIBANCode ?? '',
	// 				bankAccountNumber: formData.bankInfo.bankAccountNumber ?? '',
	// 				ngoTaxId: formData.taxId,
	// 				ngoAddress: `${formData.address}, ${formData.city}, ${formData.postalCode}`,
	// 				nowDate: new Date().toLocaleDateString(),
	// 			},
	// 			locale: contractLocale,
	// 			captchaToken,
	// 		});

	// 		const byteCharacters = atob(base64);
	// 		const byteArray = Uint8Array.from(byteCharacters, (c) => c.charCodeAt(0));
	// 		const blob = new Blob([byteArray], { type: 'application/pdf' });
	// 		downloadFile(blob, `contract-${formData.name}.pdf`);
	// 	} catch {
	// 		toast.error(t`Failed to generate contract`);
	// 	}
	// };

	return (
		<div className="flex flex-col gap-6">
			<Card className="shadow-warm items-center text-center">
				<div className="w-full px-4">
					<div className="bg-primary/10 flex h-[202px] w-full items-center justify-center overflow-hidden rounded-xl">
						<motion.div
							initial={{ opacity: 0, y: 40 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.5, ease: 'easeOut' }}
						>
							<DonatingIllustration className="text-primary mx-auto h-[180px]" />
						</motion.div>
					</div>
				</div>
				<CardContent className="flex flex-col gap-6">
					<CardTitle className="mt-8 text-2xl">{t`Registration Complete!`}</CardTitle>
					{/* <CardDescription className="mt-3 leading-relaxed">
						{t`Your organization has been registered successfully. You can download your contract below and start creating projects.`}
					</CardDescription>

					<div className="flex items-center justify-center gap-4">
						<Select value={contractLocale} onValueChange={(v) => setContractLocale(v as typeof contractLocale)}>
							<SelectTrigger className="w-32">
								<SelectValue />
							</SelectTrigger>
							<SelectContent position="popper">
								<SelectItem value="es">Español</SelectItem>
								<SelectItem value="en">English</SelectItem>
								<SelectItem value="ca">Català</SelectItem>
								<SelectItem value="it">Italiano</SelectItem>
							</SelectContent>
						</Select>

						<Button type="button" variant="outline-dark" onClick={handleDownloadContract} disabled={isContractPending}>
							<DownloadIcon className="mr-2 size-4" />
							{isContractPending ? t`Generating...` : t`Download Contract`}
						</Button>
					</div> */}

					<Button size="xl" onClick={handleGoToProjects}>
						{t`Go to Projects`}
					</Button>
				</CardContent>
			</Card>
		</div>
	);
}
